<template>
  <div class="list-group-item list-group-item-action">
    <p class="h5"><strong>
      <template v-if="result.url?.raw">
        <a
          :href="result.url.raw"
          data-event="site-interaction"
          :data-category="result.id.raw"
          data-type="link"
          :data-value="result.title.raw"
          @click="handleClick"
        >
          <span v-if="isAcademic">{{ result.curriculumItemCode.raw }}</span> {{ result.title.raw }}
        </a>
      </template>
      <template v-else>
        <span v-if="isAcademic">{{ result.curriculumItemCode.raw }}</span> {{ result.title.raw }}
      </template>
    </strong></p>
    <!--<p v-if="result.url?.raw" class="small text-muted">{{ result.url.raw }}</p>-->
    <div v-if="isStaff">
      <p class="small">{{ result.positionTitle.raw }}</p>
      <p class="small">{{ result.supervisoryOrg.raw }}</p>
      <p v-if="result['location.roomNumber']?.raw" class="small">
        <i class="fa fa-map-marker fa-fw" aria-hidden="true"></i> <a :href="'https://maps-test.murdoch.edu.au/?search='+ result['location.roomNumberCode'].raw">{{ result['location.roomNumber'].raw + " " + result['location.campus'].raw }}</a>
      </p>
      <p v-if="result.phoneNumber?.raw" class="small"><i class="fa fa-phone fa-fw" aria-hidden="true"></i> <a :href="'tel:' + result.phoneNumber?.raw">{{ result.phoneNumber.raw }}</a></p>
      <p v-if="result.emailAddress?.raw" class="small"><i class="fa fa-envelope fa-fw" aria-hidden="true"></i> <a :href="'mailto:' + result.emailAddress?.raw">{{ result.emailAddress.raw }}</a></p>
    </div>
    <p v-if="isAcademic">
      {{ result.role.raw }} 
      <template v-if="result.email?.raw">
        <a :href="'mailto:'+result.email.raw">
          {{ result.fullname.raw }}
        </a>
      </template>
      <template v-else>
        {{ result.fullname.raw }}
      </template>
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ref } from 'vue';

const results = ref([]);

const emit = defineEmits(['linkClicked'])

const handleClick = (event) => {
  emit('linkClicked', event)
}

const { result } = defineProps({
  result: {
    type: Object,
    required: true
  }
})

const isStaff = computed(() => { return result.id.raw.includes('staff') })
const isAcademic = computed(() => { return result.id.raw.includes('academic') })
</script>